import lodash from "lodash";
import React, { useContext } from "react";
import { RicosContext } from "./../../ricos-context/index.js";
import { activateCaption } from "./../../_shared/figure/activate-caption.js";
import { isNodeSelected } from "./../../_shared/is-node-selected.js";
import generalStyles from "../../editor-common/statics/styles/general-scss.js";
import generalRTLIgnoredStyles from "../../wix-rich-content-common/statics/styles/general-scss.js";
const stylesWithRTL = { ...generalStyles, ...generalRTLIgnoredStyles };
import classNames from "classnames";
import { AddCaptionButton } from "./../../_shared/figure/add-caption-button.js";
import classes from "./figure-scss.js";
const MIN_WIDTH_FOR_ADD_CAPTION_BUTTON = 116;
const MIN_WIDTH_FOR_ADD_CAPTION_BUTTON_WITH_ICON = 150;
const Figure = ({ NodeViewContent, ...props }) => {
  const { isMobile } = useContext(RicosContext);
  const { editor, node } = props;
  const pmNode = node.toJSON();
  const mainChild = pmNode.content[0];
  if (!mainChild) {
    return null;
  }
  const width = getContainerWidth(mainChild.attrs, isMobile);
  const isFigureSelected = isNodeSelected(editor.state, node.attrs.id);
  const captionNode = pmNode.content[1];
  const captionHasContent = !!captionNode?.content?.length;
  const captionIsVisible = !!captionNode?.attrs?.showEmpty || captionHasContent;
  const shouldShowAddCaptionButton = isFigureSelected && !captionHasContent && !captionIsVisible && (!width || Number(width) >= MIN_WIDTH_FOR_ADD_CAPTION_BUTTON);
  const shouldShowAddCaptionIcon = !width || Number(width) >= MIN_WIDTH_FOR_ADD_CAPTION_BUTTON_WITH_ICON;
  const handleAddCaption = () => {
    const captionNode2 = pmNode.content[1];
    if (captionNode2 && captionNode2.attrs?.id) {
      activateCaption(editor.view, captionNode2.attrs.id);
    }
  };
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      style: {
        width: width ? `min(100%, ${width}px)` : void 0,
        position: shouldShowAddCaptionButton ? "relative" : void 0
      },
      "data-hook": `figure-${mainChild.type}`,
      className: getContainerClasses(mainChild.attrs.containerData)
    },
    /* @__PURE__ */ React.createElement(
      NodeViewContent,
      {
        as: "figure",
        className: classNames(classes.figure, {
          [classes.figureWithCaption]: shouldShowAddCaptionButton
        })
      }
    ),
    shouldShowAddCaptionButton && /* @__PURE__ */ React.createElement(AddCaptionButton, { onAddCaption: handleAddCaption, showIcon: shouldShowAddCaptionIcon })
  );
};
const getContainerWidth = (nodeData, isMobile) => {
  const disableCustomWidthMapper = nodeData?.image?.width && isMobile && (Number(nodeData?.containerData?.width?.custom) || 0) > 150;
  const disableCustomWidth = disableCustomWidthMapper ?? false;
  const customWidth = !disableCustomWidth ? nodeData?.containerData?.width?.custom : void 0;
  const originalWidth = nodeData?.containerData?.width?.size === "ORIGINAL" || disableCustomWidth ? nodeData?.image?.width : void 0;
  const width = customWidth || originalWidth;
  return width;
};
const getContainerClasses = (containerData) => {
  const alignment = containerData?.alignment;
  const alignmentClassName = alignment ? stylesWithRTL[`align${lodash.upperFirst(alignment.toLowerCase())}`] : void 0;
  const size = containerData?.width?.size;
  const sizeClassName = size && size !== "FULL_WIDTH" ? stylesWithRTL[`size${lodash.upperFirst(size.toLowerCase())}`] : void 0;
  const textWrap = containerData?.textWrap;
  const textWrapClassName = textWrap ? void 0 : stylesWithRTL.textWrapNowrap;
  return classNames(alignmentClassName, sizeClassName, textWrapClassName);
};
export {
  Figure
};
//# sourceMappingURL=figure.js.map
